const KST_OFFSET_MS = 9 * 60 * 60 * 1000

// 조회 시점(KST 기준) 전월을 "YYYY년 M월" 형식으로 표기한다. (예: 10월에 조회하면 "9월")
// 서버 타임존이 UTC여도 월 경계에서 어긋나지 않도록 KST로 보정한 뒤 계산한다.
export const formatPreviousYearMonth = (): string => {
  const nowKst = new Date(Date.now() + KST_OFFSET_MS)
  const previousMonth = new Date(
    Date.UTC(nowKst.getUTCFullYear(), nowKst.getUTCMonth() - 1, 1)
  )
  return `${previousMonth.getUTCFullYear()}년 ${previousMonth.getUTCMonth() + 1}월`
}

export const formatPlaceIntroductionDate = (): string =>
  `${formatPreviousYearMonth()} 누적 실거래 기준`
